import React, { useRef } from "react";

import Image from "../../../../components/image";
import Icon from "../../../../components/icon";
import Slider from "src/@components/slider/slider.component";
import CTAButton from "src/components/ctabutton/ctabutton";

export default function GalleryModalV2({ closeFn, images, open, initialImageIndex = 0, buttonHref = "", buttonText = "", onImageChange = (index) => {} }) {
  const modalRef = useRef(null);
  React.useEffect(() => {
    if (open) {
      modalRef.current.focus();
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [open]);


  if (!open) return null;
  return (
    <div className="fixed z-[201] inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true" onKeyDown={(e) => e.key === "Escape" && closeFn()} ref={modalRef} tabIndex={0}>
      <button className=" text-white absolute top-10 right-10 z-10" onClick={closeFn}>
        <Icon icon="X" className="w-6 h-6" />
      </button>
      <div className="flex items-center justify-center min-h-[calc(var(--vh,_1vh)_*_100)] pb-4 pt-[5rem] text-center sm:p-0">
        <div role="button" tabIndex={-1} onKeyDown={closeFn} onClick={closeFn} className="fixed inset-0 bg-gray-700 bg-opacity-75 transition-opacity" aria-hidden="true" />
        <span className="hidden sm:inline-block align-middle sm:h-[calc(var(--vh,_1vh)_*_100)]" aria-hidden="true">&#8203;</span>
        <div className={`w-full max-w-7xl mx-4 relative inline-block text-left shadow-xl transform transition-all sm:my-8 align-middle overflow-auto`}>
          <Slider
            slidesPerView={1}
            autoHeight={true}
            initialSlide={initialImageIndex}
            navigation={true}
            pagination={false}
            navigation_position="absolute"
            navigation_color="#fff"
            navigation_bg="#242426B3"
            className="h-full"
            onTabChange={(index) => onImageChange(index)}
          >
            {
              images && images.length
                ? images.map((image, idx) => (
                  <div key={`image-${idx}`} className="relative w-full h-full aspect-[16/9]">
                    <Image src={image} className={`w-full h-full object-cover`}  />
                    {buttonHref && buttonText && (
                      <CTAButton
                      link={buttonHref}
                      text={buttonText}
                      type="primary"
                      color="var(--cta-color)"
                      bgcolor="var(--cta-bg-color)"
                      hovercolor="var(--cta-color)"
                      hoverbgcolor="var(--cta-bg-color)"
                      className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
                      open_in_same_tab={false}
                      />
                    )}
                  </div>
                ))
                : null
            }
          </Slider>
        </div>
      </div>
    </div>
  )
}
